import { StorageActions, StorageMsg } from '../storage.actions';

const ONE_DAY = 60 * 60 * 24 * 1000;

export function storageSetOneDay(key: string, value: any) {
    return StorageMsg(StorageActions.Set, { key, value, expiry: new Date().getTime() + ONE_DAY });
}
